import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { TodoTasksBoard } from '@demind-inc/core';
import { Checkbox, FormControlLabel, IconButton } from '@mui/material';
import { DeleteOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import './TodoListProject.scss';
import { debounce } from 'lodash';

interface TodoListProjectProps {
  project: TodoTasksBoard;
  defaultSelected: boolean;
  onSelect: (checked: boolean) => void;
  onDelete?: () => void;
  canDelete?: boolean;
  className?: string;
}

const TodoListProject: React.FC<TodoListProjectProps> = ({
  project,
  defaultSelected,
  onSelect,
  onDelete,
  canDelete = false,
  className,
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(defaultSelected);

  useEffect(() => {
    setSelected(defaultSelected);
  }, [defaultSelected]);

  const debouncedSelectApi = useCallback(
    debounce((newSelected: boolean) => {
      onSelect(newSelected);
    }, 1000),
    []
  );

  const handleSelect = (newSelected: boolean) => {
    setSelected(newSelected);
    debouncedSelectApi(newSelected);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <div className={clsx('todo-list-project__container', className)}>
      <FormControlLabel
        className="todo-list-project calendar-list-item"
        control={
          <Checkbox
            size="small"
            checked={selected}
            onChange={(e) => handleSelect(e.target.checked)}
          />
        }
        label={`# ${project.name}`}
      />
      {canDelete && onDelete && (
        <IconButton
          size="small"
          className="todo-list-project__delete-button"
          onClick={handleDelete}
          aria-label={t('task.project.deleteProject')}
        >
          <DeleteOutlined fontSize="small" />
        </IconButton>
      )}
    </div>
  );
};

export default TodoListProject;
